<template>
  <div ref="container" :class="$style.container">
    <div ref="list" :class="$style.list">
      <div :class="$style.group" v-for="group in groups" :key="group.id">
        <div :class="$style.groupTitle">{{ group.title }}</div>
        <div
          :class="$style.building"
          v-for="building in group.buildings"
          :key="building.id"
          @click="onSelectBuilding(building.id)"
        >
          {{ building.title }} <span v-if="$can('support', 'write')" :class="$style.id">#{{ building.id }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HousesSelectList",
  computed: {
    groups() {
      return this.$store.getters['appUser/groupedHouses'];
    },
  },
  methods: {
    resetListWidth() {
      this.$refs.list.style.width = '';
      this.$nextTick(this.setListWidth);
    },

    setListWidth() {
      const { list } = this.$refs;
      const lastChild = list.children[list.children.length - 1];
      if (!lastChild) return;
      list.style.width = lastChild.offsetLeft + lastChild.clientWidth + 'px';
    },

    setContainerMaxWidth() {
      const { container } = this.$refs;
      const { x } = container.getBoundingClientRect();
      container.style.maxWidth = window.innerWidth - x - 20 + 'px';
    },

    updateLayout() {
      this.resetListWidth();
      this.setContainerMaxWidth();
    },

    onSelectBuilding( buildingId ) {
      const houses = this.$store.getters['appUser/houses'];
      const house = houses.find(house => house.id === buildingId);
      this.$store.dispatch('appUser/UPDATE_SELECTED_HOUSE', house);
    },
  },

  mounted() {
    window.addEventListener('resize', this.updateLayout);
    // this.updateGroups();
    this.$nextTick(this.updateLayout);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateLayout);
  },

  watch: {
    houses() {
      // this.updateGroups();
      this.$nextTick(this.resetListWidth);
    },
  },
};
</script>


<style lang="scss" module>
.container {
  overflow: auto;
}

.list {
  column-width: 320px;
  column-fill: balance;
  column-rule: 1px solid rgba(#000, .1);
  column-gap: 0;

  margin-top: -1px;
  margin-bottom: 1px;
  position: relative;
  height: 100%;
}

.group {
  border-top: 1px solid rgba(#000, .1);
  padding-bottom: 5px;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
  width: 320px;
}

.groupTitle {
  padding: 10px;
  font-weight: 500;
  margin-bottom: 5px;
  position: relative;
}

.building {
  cursor: pointer;
  padding: 5px 10px 5px 25px;
  @include anim(.1s);

  &:hover {
    background: color(primary);
    color: #fff;
  }
}

.id {
  opacity: .5;
}
</style>
